import { render, staticRenderFns } from "./DriversSelect.vue?vue&type=template&id=5ffb2adc&scoped=true"
import script from "./DriversSelect.vue?vue&type=script&lang=ts"
export * from "./DriversSelect.vue?vue&type=script&lang=ts"
import style0 from "./DriversSelect.scss?vue&type=style&index=0&id=5ffb2adc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb2adc",
  null
  
)

export default component.exports